<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 11 11"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M8.829 2.02L8.8 6.775C8.787 9.144 7.573 10.3 5.697 10.3c-2 0-3.297-1.51-3.297-3.921V4.122h.22c.525 0 .815.353.815.734v1.03l.33.366V1.626c0-.38.221-.62.525-.62.303 0 .51.24.51.62v3.61h.318V.906c0-.366.207-.606.524-.606.276 0 .497.24.497.606v4.33h.317V1.428c0-.366.234-.606.538-.606.276 0 .497.24.497.606l-.014 3.808h.317V2.021c0-.381.248-.607.497-.607.275 0 .538.226.538.607z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
